import { useQuery } from '@tanstack/react-query'
import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'

export interface PaymentSummary {
  total_incoming: string
  total_outgoing: string
  net_income: string
}

export const paymentSummaryQueryKey = (month?: string) => ['payment-summary', month]

export function usePaymentSummary(month?: string) {
  async function getPaymentSummary(): Promise<PaymentSummary> {
    const params = month ? { month } : {}
    const response = await apiClient.get<PaymentSummary>(
      SNA_PREFIX + 'dashboard/payment-summary',
      { params }
    )
    return response.data
  }

  return useQuery({
    queryFn: getPaymentSummary,
    queryKey: paymentSummaryQueryKey(month)
  })
}
